import { render, staticRenderFns } from "./TheMenuSettingsLink.vue?vue&type=template&id=327fbd45&scoped=true&"
import script from "./TheMenuSettingsLink.vue?vue&type=script&lang=js&"
export * from "./TheMenuSettingsLink.vue?vue&type=script&lang=js&"
import style0 from "./TheMenuSettingsLink.vue?vue&type=style&index=0&id=327fbd45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327fbd45",
  null
  
)

/* custom blocks */
import block0 from "./TheMenuSettingsLink.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./TheMenuSettingsLink.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemContent,VListItemTitle})
